import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { HeaderBarComponent } from '@components/header-bar/header-bar.component'
import { IntegrationSidebarComponent } from '@components/integration-platform/integration-sidebar/integration-sidebar.component'
import { environment } from '@env/environment'

@Component({
  selector: 'app-integration-platform',
  templateUrl: './integration-platform.component.html',
  styleUrl: './integration-platform.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Material
    MatCardModule,
    MatIconModule,

    // Components
    IntegrationSidebarComponent,
    HeaderBarComponent,
  ],
})
export class IntegrationHomeComponent {
  contactEmail = environment.contactEmail
}
